import type * as React from "react";

import { drawSprite, type SpriteTraits } from "./sprites";
import { cn } from "../lib/cn";

export type PatientSpriteSize = 20 | 28 | 44 | 56;

export interface PatientSpriteProps extends Omit<
  React.SVGAttributes<SVGSVGElement>,
  "children" | "viewBox" | "width" | "height"
> {
  /** brian's `sprite`; missing draws the paw while the patient loads. */
  sprite?: SpriteTraits | null;
  size?: PatientSpriteSize;
  label?: string;
  ref?: React.Ref<SVGSVGElement>;
}

/** A deceased sprite's wings overflow its box, so layouts keep the same footprint. */
export function PatientSprite({
  sprite,
  size = 28,
  label,
  className,
  ...rest
}: PatientSpriteProps) {
  const drawing = drawSprite(sprite);

  return (
    <svg
      viewBox="0 0 16 16"
      width={size}
      height={size}
      focusable="false"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      data-sprite={drawing.name}
      overflow={drawing.wings ? "visible" : undefined}
      {...rest}
      className={cn(
        "inline-block shrink-0 text-ink render-pixelated",
        className,
      )}
    >
      {drawing.wings?.map((p) => (
        <path key={`wing-${p.fill}`} fill={p.fill} d={p.d} />
      ))}
      <g opacity={drawing.wings ? 0.4 : undefined}>
        {drawing.body.map((p) => (
          <path key={p.fill} fill={p.fill} d={p.d} />
        ))}
      </g>
    </svg>
  );
}
